// tslint:disable:max-line-length

import React from 'react';

export const EditorLayout = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,0v16h16V0H0z M14.5,14.5h-13v-13h13V14.5z" />
      <rect x="8.5" y="2.5" width="5" height="1" />
      <rect x="2.5" y="2.5" width="5" height="11" />
      <rect x="8.5" y="4.5" width="5" height="1" />
      <rect x="8.5" y="6.5" width="5" height="1" />
      <rect x="8.5" y="8.5" width="5" height="1" />
      <rect x="8.5" y="10.5" width="5" height="1" />
      <rect x="8.5" y="12.5" width="2.9" height="1" />
    </svg>
  );
};
